module.exports = __webpack_public_path__ + "static/zitno-polje-65a576717a46c564a5d21f9967f5e679.jpg";